import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ ]

  connect() {
    this.determineBackorderListedAmount()
    this.determineStateOfCreateOrUpdateButton()
    this.blankAmountIfZero()
    this.determineStartStateForExtraTextRow()
    this.setCheckBoxesOnLoad()
    this.countCharactersForExtraRow()
  }

  // helper methods

  // ROW
  // Get the row, must provide a input element on the same row.
  getRowFromRowInputElement(rowInputElement) {
    return rowInputElement.parentElement.parentElement
  }

  getMaxAmountFromRow(row) {
    return row.getElementById('max-amount').lastChild
  }

  getAmountFromRow(row) {
    return row.getElementById('amount').lastChild
  }

  getAlreadyPickedAmountFromRow(row) {
    return row.getElementById('already-picked-amount').firstChild
  }

  getBackorderListedFromRow(row) {
    return row.getElementById('backorder-listed')
  }

  getSavedAmountWhenMarkedFromRow(row) {
    return row.getElementById('amount-when-marked')
  }

  getTextRowBoolFromRow(row) {
    return row.getElementById('text-row-bool')
  }

  // DOCUMENT
  getExtraTextRowButton() {
    return document.getElementById('add-or-remove-extra-text-row-button')
  }

  getIsSpecialUseExtraTextRow() {
    return this.getExtraTextRow().getElementById('is-special-use-extra-text-row')
  }

  getExtraTextRow() {
    var table = this.getPicklistTable()
    return table.rows[table.rows.length - 1]
  }

  getPicklistTable() {
    return document.getElementById('picklist-table')
  }

  get extraTextArea() {
    return $('extra-text-text-area')
  }

  get bodyTextCounter() {
    return $('body_text_counter')
  }

  // FUNCTIONS
  countCharactersForExtraRow() {
    this.bodyTextCounter.textContent = this.extraTextArea.textLength
  }

  determineStartStateForExtraTextRow() {
    var extraTextRow = this.getExtraTextRow()
    this.changeExtraTextRow(extraTextRow.children[0].lastChild.value != '')
  }

  changeExtraTextRow(show) {
    var extraTextRow = this.getExtraTextRow()
    var extraTextRowButton = this.getExtraTextRowButton()
    if (show) {
      extraTextRowButton.innerText = I18n.load('remove_extra_text_row_button_text')
      var mark_use_extra_text_row = this.getIsSpecialUseExtraTextRow()
      mark_use_extra_text_row.value = 'true'
      extraTextRow.classList.remove('hidden')
    } else {
      extraTextRow.classList.add('hidden')
      extraTextRowButton.innerText = I18n.load('add_extra_text_row_button_text')
      var mark_use_extra_text_row = this.getIsSpecialUseExtraTextRow()
      mark_use_extra_text_row.value = ''
    }
  }

  addOrRemoveExtraTextRow() {
    var extraTextRow = this.getExtraTextRow()
    this.changeExtraTextRow(extraTextRow.classList.contains('hidden'))
  }

  countDecimals(number_string) {
    var decimals = number_string.split('.')
    if (decimals.length > 1) {
      return decimals[1].length
    }
    return 0
  }

  toggler(row, checked, saveOrUseOldValue) {
    var amount_when_marked = this.getSavedAmountWhenMarkedFromRow(row)
    var amount = this.getAmountFromRow(row)
    if (checked) {
      if (saveOrUseOldValue) {
        amount_when_marked.value = amount.value
      }
      // set amount to max - backorder_intial
      amount.value =  String(parseFloat(this.getMaxAmountFromRow(row).nodeValue) - parseFloat(this.getAlreadyPickedAmountFromRow(row).nodeValue))
    } else {
      if (saveOrUseOldValue) {
        amount.value = amount_when_marked.value
      }
    }
  }

  toggleAll(e) {
    var rows = this.getPicklistTable().rows
    var rowsArray = Array.from(rows).slice(0, -1)
    rowsArray.forEach(row => {
      // unless state is same as the state being toggled to.
      var checkBox = row.cells[0].lastChild
      if (e.target.checked != checkBox.checked) {
        this.toggler(row, e.target.checked, true)
        this.determineBackorderListedAmountFromRow(row, false)
      }
    });
  }

  toggleRow(e) {
    this.toggler(this.getRowFromRowInputElement(e.target), e.target.checked, true)
    this.determineBackorderListedAmount(e)
  }

  blankAmountIfZero() {
    var table = document.getElementById('picklist-table')
    var rowsArray = Array.from(table.rows).slice(1)
    for (let i = 0; i < rowsArray.length; i++) {
      var row = rowsArray[i]
      if (this.getTextRowBoolFromRow(row).value == "true") {
        continue
      }
      var amountElement = this.getAmountFromRow(row)
      var rowAmount = parseFloat(amountElement.value)
      if (rowAmount == 0) {
        amountElement.value = ''
      }
    }
  }

  // determines if the mark all box should change
  determineMarkAll() {
    var rows = this.getPicklistTable().rows
    var rowsArray = Array.from(rows).slice(0, -1)
    var markAllBox = true
    for (let i = 1; i < rowsArray.length; i++) {
      var row = rowsArray[i]
      var checkBox = row.cells[0].lastChild
      if (checkBox.checked == false) {
        markAllBox = false
        break
      }
    }

    // mark the all checkbox if true
    rowsArray[0].cells[0].lastChild.checked = markAllBox
  }

  determineAutoFillMarkPickAll(backorder_listed_amount, row, updateMarkAll) {
    var checkBox = row.cells[0].lastChild
    if (backorder_listed_amount == 0 && checkBox.checked == false) {
      checkBox.checked = true
      this.toggler(row, checkBox.checked, false)
    } else if (backorder_listed_amount != 0 && checkBox.checked == true) {
      checkBox.checked = false
      this.toggler(row, checkBox.checked, false)
    }
    if (updateMarkAll) {
      this.determineMarkAll()
    }
  }

  determineStateOfCreateOrUpdateButton() {
    var table = document.getElementById('picklist-table')
    var createOrUpdateButton = document.getElementById('create-or-update-form-button')
    var rowsArray = Array.from(table.rows).slice(1)
    for (let i = 0; i < rowsArray.length; i++) {
      var row = rowsArray[i]
      if (this.getTextRowBoolFromRow(row).value == "true") {
        continue
      }
      var amount = this.getAmountFromRow(row).value
      var rowAmount = parseFloat(amount)
      if (rowAmount != 0 &&  amount != '') {
        createOrUpdateButton.disabled = false
        createOrUpdateButton.style.filter = 'none'
        createOrUpdateButton.style.cursor = 'auto'
        delete createOrUpdateButton.dataset.tooltip
        return
      }
    }
    createOrUpdateButton.disabled = true
    createOrUpdateButton.style.filter = 'grayscale(100%)'
    createOrUpdateButton.style.cursor = 'not-allowed'
    createOrUpdateButton.dataset.tooltip = I18n.load('tt_create_or_update_delivery_note')
  }

  determineBackorderListedAmountFromRow(row, updateMarkAll) {
    var amount = this.getAmountFromRow(row)
    amount.value = amount.value.replace(/,/, '.')

    var float_orderedAmount = parseFloat(this.getMaxAmountFromRow(row).nodeValue)
    var float_amount = parseFloat(amount.value)
    if (isNaN(float_orderedAmount)) {
      float_orderedAmount = 0.0
    }
    if (isNaN(float_amount)) {
      float_amount = 0.0
    }
    // count highest number of decimals in use
    var alreadyPickedAmount = this.getAlreadyPickedAmountFromRow(row)
    var countDecimalsForAlreadyPickedAmount = this.countDecimals(alreadyPickedAmount.nodeValue)
    var countDecimalsForAmount = this.countDecimals(String(float_amount))
    var maxNumberOfDecimals = Math.max(countDecimalsForAlreadyPickedAmount, countDecimalsForAmount)
    var float_alreadyPickedAmount = parseFloat(alreadyPickedAmount.nodeValue)
    var backorderListed = this.getBackorderListedFromRow(row)
    // round value to highest number of decimals.
    backorderListed.innerText = (float_orderedAmount - float_amount - float_alreadyPickedAmount).toFixed(maxNumberOfDecimals)
    this.determineStateOfCreateOrUpdateButton()
    this.determineAutoFillMarkPickAll(parseFloat(backorderListed.innerText), row, updateMarkAll)
  }

  determineBackorderListedAmount(e) {
    if (e === undefined) {
      return
    }
    e.preventDefault()
    this.determineBackorderListedAmountFromRow(this.getRowFromRowInputElement(e.target), true)
  }

  setCheckBoxesOnLoad() {
    var rows = this.getPicklistTable().rows
    var rowsArray = Array.from(rows).slice(0, -1)
    var markAllBox = true
    for (let i = 1; i < rowsArray.length; i++) {
      var row = rowsArray[i]
      if (parseFloat(this.getBackorderListedFromRow(row).innerText) == 0) {
        var checkBox = row.cells[0].lastChild
        checkBox.checked = true
        this.toggler(row, checkBox.checked, false)
      } else {
        markAllBox = false
      }
    }

    // mark the all checkbox if true
    rowsArray[0].cells[0].lastChild.checked = markAllBox
  }
}
